<template>
  <div class="svg-icon" :style="{width: this.size + 'px', height: this.size + 'px'}" :name="name"></div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      img: "",
      pathUrl: this.path || "icons"
    };
  },
  props: [
    "name",
    "fill",
    "path",
    "fillOpacity",
    "size",
    "width",
    "height",
    "icon"
  ],
  mounted() {
    this.fetchSomething();
  },
  methods: {
    async fetchSomething() {
      let data = await axios.get(this.icon);
      data = data.data.replace("<svg", `<svg style="display: block"`);
      if (this.fill) {
        data = data.replace("<path", `<path fill="${this.fill}"`);
      }
      if (this.fillOpacity) {
        data = data.replace(
          "<path",
          `<path fill-opacity="${this.fillOpacity}"`
        );
      }
      if (this.size) {
        data = data.replace("<svg", `<svg width="100%" height="100%"`);
      }
      if (this.width) {
        data = data.replace("<svg", `<svg width="${this.width}"`);
      }
      if (this.heigth) {
        data = data.replace("<svg", `<svg heigth="${this.heigth}"`);
      }
      this.img = data;
      this.$el.innerHTML = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.svg-icon {
  width: 100%;
  svg {
    width: 100%;
  }
}
</style>
